<!-- src/components/SideBar.vue -->
<template>
  <div id="sideMenuBar" class="side-menu-content" :class="{ active: app.sideMenuOpen }">
    <div class="sidebar-content">
      <div class="modal-header" @click="app.closeSideMenu()">
        <div class="modal-title logo">
          <span class="toggle-theme">
            <i class="dark-theme" :style="{ display: isDarkMode ? 'inline' : 'none' }">
              <img :src="images.logoReverse" alt="Mossbets" />
            </i>
            <i class="light-theme" :style="{ display: isDarkMode ? 'none' : 'inline' }">
              <img :src="images.logo" alt="Mossbets" />
            </i>
          </span>
          <button type="button" class="close" @click.stop="app.closeSideMenu()">
            <span aria-hidden="true"><i class="bi bi-x"></i></span>
          </button>
        </div>
      </div>

      <div class="sidenav-content">
        <div id="popularLeagues" class="accounts-card">
          <div class="card-header">Top Leagues</div>

          <!-- Dynamic tournament links -->
          <span v-for="tournament in popularTournaments" :key="tournament.tournament_id" class="menulink">
            <a href="javascript:void(0)" @click.prevent="handleTournamentClick(tournament)" class="tournament-link">
              <span class="linkicon"><img :src="getCountryFlag(tournament.country_code)" :alt="tournament.country" /></span>
              <span class="linktext">{{ tournament.tournament }}</span>
            </a>
          </span>

          <span class="menulink">
            <RouterLink to="/countries" @click="onNavigate">
              <span class="linkicon"><img :src="icons.globe" alt="Globe" /></span>
              <span class="linktext">A-Z Countries</span>
            </RouterLink>
          </span>
        </div>

        <div id="popularGames" class="accounts-card">
          <div class="card-header">Popular Games</div>

          <span class="menulink">
            <RouterLink to="/" @click="onNavigate">
              <span class="linkicon"><i class="fi fi-rr-football"></i></span>
              <span class="linktext">Sports</span>
            </RouterLink>
          </span>

          <span class="menulink">
            <RouterLink to="/live-games" @click="onNavigate">
              <span class="linkicon"><i class="fi fi-rr-live-alt"></i></span>
              <span class="linktext">Live</span>
            </RouterLink>
          </span>

<!--          <span class="menulink">
            <RouterLink to="/jackpot" @click="onNavigate">
              <span class="linkicon"><i class="fi fi-rr-sack"></i></span>
              <span class="linktext">Jackpot</span>
            </RouterLink>
          </span>-->

          <span class="menulink aviatrix">
            <RouterLink :to="{ name: 'aviatrix' }" @click="onNavigate">
              <span class="linkicon">
                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                  <path fill="var(--text-color)" d="M101.91,132.29a26.9,26.9,0,0,0,5.45,11.65,24.42,24.42,0,0,0,7.91,6.48c1,.52,1.23,1,.82,2.16-4.55,12.33-8.15,25-13.39,37.09s-11.77,22.91-22.56,30.76a34,34,0,0,1-20.82,6.86c-9.24-.09-18.48,0-27.72,0h-.21c-2.47,0-5.13.07-6.36-2.57s.58-4.65,2.17-6.49q16.1-18.59,32.25-37.12l41.13-47.32C100.9,133.39,101.24,133,101.91,132.29ZM80.15,186.57c-.15.22-.74.25-.43.64s.57,0,.75-.26.65-.37.26-.7C80.51,186.06,80.3,186.36,80.15,186.57ZM79.3,178l-.54.55c.38.26.64.13.84-.24.19-.15.59-.27.3-.58S79.48,177.87,79.3,178ZM78,171.16c0-.43.46-.86,0-1.28,1,.44,1.21-.47,1.6-1a5.12,5.12,0,0,0,1.63-1.77L94.4,152.33l.37.36a15,15,0,0,1-3.46,9.16c-3.73,4.6-7.12,9.47-10.62,14.25-.31.42-1,.79-.57,1.73L92.73,164l.37.34a12.2,12.2,0,0,1-2.88,8.44c-3.09,3.84-5.87,7.93-8.74,11.94-.32.44-1.07.81-.53,1.79l10.5-11.33.35.32a14.49,14.49,0,0,1-3,8.44C85.76,187.81,83,192,80.11,196l-.49.57a.54.54,0,0,0,.86-.2l8.78-9.29c-1.47,8.28-4.73,15.85-8.32,23.44a4.72,4.72,0,0,0,2.42-2.16c7.8-10.66,11.92-22.69,13.37-35.73,1.09-9.8,1.34-19.69,3-29.44.41-2.4.91-4.77,1.37-7.16a16.85,16.85,0,0,0-3,5.43,25.94,25.94,0,0,1-4.51,8c-4.31,5.7-8.54,11.46-12.8,17.2-.49.64-1,1.27-1.49,1.91-.54.36-.63,1.17-1.36,1.32,0,.42,0,.83,0,1.25l-.12,0Z"/>
                  <path fill="var(--text-color)" d="M154.05,123.76c-1.71-8.7-6.07-14.93-13.38-19.05a1.07,1.07,0,0,1-.53-1.56c5.3-14.4,9.16-29.35,16.05-43.15,5.14-10.3,11.81-19.42,21.56-25.93a29.71,29.71,0,0,1,17.34-5.35c9.95.14,19.9,0,29.86.05,2.38,0,5,0,6.15,2.53s-.53,4.36-2.06,6.11l-73.91,85.08C154.85,122.8,154.59,123.12,154.05,123.76ZM176.2,58.81l-.43.44L167,68.53l-.53-.33c.61-2.17,1.18-4.35,1.85-6.5,1.78-5.71,4.37-11.09,6.69-16.57l.31-.42c-.11,0-.26-.05-.31,0s-.26.31,0,.43c-1.53.48-2,1.94-2.85,3.06-7.86,10.91-11.8,23.26-13.15,36.5-.62,6.05-1.08,12.12-1.58,18.18a136.3,136.3,0,0,1-2.65,17.36,12.71,12.71,0,0,0,2.63-4.8,31.35,31.35,0,0,1,5-9.12c4.39-5.65,8.58-11.45,12.85-17.19,0-.18,0-.36,0-.54l-.43.23L161.2,104.06c0-4.18.55-6,2.75-8.93,3.53-4.76,7.08-9.52,10.6-14.3.35-.49,1.06-.92.58-2L162.94,92.47c-.27-4.14.08-5.39,2.1-8.19Q170.58,76.65,176.1,69l.31-.53c.05-.15.15-.41.12-.43-.23-.12-.29,0-.33.24l-.42.44L164.1,81.31c.2-3.34.54-6,2.41-8.42,3.36-4.34,6.43-8.9,9.61-13.36l.31-.47c0-.16.16-.43.12-.47C176.33,58.44,176.25,58.63,176.2,58.81Z"/>
                  <path fill="var(--text-color)" d="M104.53,81.06c3.51,0,7,.07,10.52,0a6,6,0,0,1,6,3.63c3.46,6.73,7.07,13.4,10.55,20.13a4.07,4.07,0,0,0,2.66,2.18,21.47,21.47,0,0,1,15,24.91A21.9,21.9,0,0,1,125.44,149c-10.93-1.07-19.82-10.51-19.38-21.46a19.51,19.51,0,0,0-2.57-10.07Q96.22,103.17,89,88.8c-2.21-4.38-.15-7.69,4.8-7.73C97.37,81,101,81.06,104.53,81.06Zm31.9,46.57a8.55,8.55,0,1,0-8.59,8.35A8.55,8.55,0,0,0,136.43,127.63Z"/>
                  <path fill="var(--text-color)" d="M121.65,153c12,2.08,21.46-1.69,28.55-11.37.75.3.84,1.07,1.14,1.66q6.39,12.61,12.76,25.24c2.14,4.25.13,7.7-4.6,7.74-7.22.05-14.45,0-21.68,0-2,0-3.94-.43-5-2.35C129.09,167.07,125.43,160.13,121.65,153Z"/>
                  <path fill="var(--text-color)" d="M94.4,152.33c.13-.1.36-.31.38-.29.22.2.13.43,0,.65Z"/>
                  <path fill="var(--text-color)" d="M92.73,164c.1-.14.17-.42.39-.23s0,.37,0,.57Z"/>
                  <path fill="var(--text-color)" d="M91.45,175.15c.09-.14.16-.41.37-.22s0,.35,0,.54Z"/>
                  <path fill="var(--text-color)" d="M166.64,68.15c.14.13.32.25.3.29a3.25,3.25,0,0,1-.32.53c-.08-.1-.24-.22-.23-.3A2.47,2.47,0,0,1,166.64,68.15Z"/>
                </svg>
              </span>
              <span class="linktext">Aviatrix</span>
            </RouterLink>
          </span>

          <span class="menulink">
            <RouterLink :to="{ name: 'aviator' }" @click="onNavigate">
              <span class="linkicon"><i class="fi fi-rr-plane-departure"></i></span>
              <span class="linktext">Aviator</span>
            </RouterLink>
          </span>

          <span class="menulink jetx">
            <RouterLink :to="{ name: 'jetx' }" @click="onNavigate">
              <span class="linkicon">
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 511.9 511.9" style="enable-background:new 0 0 511.9 511.9;" xml:space="preserve">
                  <g>
                      <path fill="var(--text-color)" d="M256,127.7c-12.5,0-24.5,1.8-35.9,5.1L240,181c5.2-1.1,10.5-1.7,16-1.7c3.5,0,6.9,0.3,10.2,0.7l33.1-44.8
                          C285.5,130.2,271,127.7,256,127.7L256,127.7z"/>
                      <circle fill="var(--text-color)" cx="256" cy="256" r="48.8"/>
                      <path fill="var(--text-color)" d="M400,195.5c8,19,12.2,39.7,12.2,60.5c0,86.1-70.1,156.2-156.2,156.2c-20.8,0-41.4-4.2-60.5-12.2l-21.2,28.7
                          c25.4,12,53.3,18.3,81.7,18.3c105.3,0,191-85.7,191-191c0-28.3-6.3-56.3-18.3-81.7L400,195.5z"/>
                      <path fill="var(--text-color)" d="M112,316.4c-8-19-12.2-39.7-12.2-60.5c0-86.1,70.1-156.2,156.2-156.2c20.8,0,41.4,4.2,60.5,12.2l21.2-28.7
                          C312.2,71.3,284.3,65,256,65C150.6,65,65,150.6,65,256c0,28.3,6.3,56.3,18.3,81.7L112,316.4z"/>
                      <path fill="var(--text-color)" d="M214.2,191.7l-19.9-48.1c-21.3,11.8-39,29.4-50.8,50.8l48.1,19.9C197.5,205.2,205.2,197.5,214.2,191.7z"/>
                      <path fill="var(--text-color)" d="M297.7,320.3l19.9,48.1c21.3-11.8,39-29.4,50.8-50.8l-48.1-19.9C314.4,306.7,306.7,314.4,297.7,320.3z"/>
                      <path fill="var(--text-color)" d="M132.8,220.1c-3.3,11.4-5.1,23.4-5.1,35.9c0,15,2.5,29.5,7.5,43.3l44.8-33.1c-0.5-3.4-0.7-6.8-0.7-10.3
                          c0-5.5,0.6-10.8,1.7-16L132.8,220.1z"/>
                      <path fill="var(--text-color)" d="M379.1,291.9c3.3-11.4,5.1-23.4,5.1-35.9c0-15-2.5-29.5-7.5-43.3L332,245.7c0.5,3.4,0.7,6.8,0.7,10.3
                          c0,5.5-0.6,10.8-1.7,16L379.1,291.9z"/>
                      <path fill="var(--text-color)" d="M256,332.7c-3.5,0-6.9-0.3-10.2-0.7l-33.1,44.8c13.8,5,28.3,7.5,43.3,7.5c12.5,0,24.5-1.8,35.9-5.1L271.9,331
                          C266.8,332.1,261.4,332.7,256,332.7L256,332.7z"/>
                      <path fill="var(--text-color)" d="M32.2,479.7c15.6,15.6,39.2,18.4,57.7,8.4L23.8,422C13.8,440.5,16.6,464.1,32.2,479.7z"/>
                      <path fill="var(--text-color)" d="M189.4,294L43.2,402l66.8,66.8l108-146.2C206.1,315.7,196.2,305.8,189.4,294L189.4,294z"/>
                      <path fill="var(--text-color)" d="M294,189.4c11.9,6.8,21.8,16.7,28.6,28.6l146.2-108L402,43.2L294,189.4z"/>
                      <path fill="var(--text-color)" d="M479.7,32.2c-15.6-15.6-39.2-18.4-57.7-8.4l66.1,66.1C498.1,71.4,495.3,47.8,479.7,32.2z"/>
                  </g>
                  </svg>
              </span>
              <span class="linktext">JetX</span>
            </RouterLink>
          </span>

          <span class="menulink">
            <RouterLink to="/instant-games" @click="onNavigate">
              <span class="linkicon"><i class="fi fi-rr-circle-star"></i></span>
              <span class="linktext">Instant</span>
            </RouterLink>
          </span>

          <span class="menulink">
            <RouterLink :to="{name: 'ShackGames'}" @click="onNavigate">
              <span class="linkicon">
                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
                  <path fill="var(--text-color)" d="M273.8,149.42l-229.17,241H253.72c2.2-.31,4.39-.68,6.55-1.1,59.17-11.56,103.83-61.72,103.83-121.68C364.1,212.39,326.11,165.46,273.8,149.42ZM255.46,347.26c-1.55.37-3.12.72-4.7,1V189a80.86,80.86,0,0,1,4.7,158.25Z"/>
                  <path fill="#54af32" d="M250.76,348.26c43.32,0,78.45-35.65,78.45-79.63S294.08,189,250.76,189Z"/>
                  <path fill="none" d="M138.58,208.34A80.6,80.6,0,0,0,149.24,211V51.74c-1.58.28-3.15.63-4.7,1a80.86,80.86,0,0,0-6,155.6Z"/>
                  <path fill="var(--text-color)" d="M126.2,250.58l229.17-241H146.28c-2.2.31-4.39.68-6.55,1.1C80.56,22.21,35.9,72.37,35.9,132.33,35.9,187.61,73.89,234.54,126.2,250.58ZM144.54,52.74c1.55-.37,3.12.72,4.7-1V211a80.86,80.86,0,0,1-4.7-158.25Z"/>
                </svg>
              </span>
              <span class="linktext">Shacks Evo</span>
            </RouterLink>
          </span>

          <span class="menulink">
            <RouterLink :to="{name: 'PragmaticGames'}" @click="onNavigate">
              <span class="linkicon">
                <svg id="_Layer_" data-name=" Layer " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 364.2 364.2">
                  <path fill="#f19021" d="M198.06,143.55c-37.81,2.35-20.83,51.58,21,49C259.91,190,238.34,141,198.06,143.55Z"></path>
                  <path fill="#f19021" d="M182.1,113.13a121.8,121.8,0,1,0,121.8,121.8h0A121.8,121.8,0,0,0,182.1,113.13Zm0,230.84a109,109,0,1,1,109-109v0A109,109,0,0,1,182.1,344ZM178.43,28.11C149.51,50,154.54,83.48,154.54,83.48s-18.18-47.17-41.78-76c-3.18,37.12,8.45,86.31,8.45,86.31s-14.78-30.5-51-32.2c30,17.26,41.69,48.36,44.35,56.71a121.07,121.07,0,0,1,59.4-18C171.6,92.54,163.18,59.81,178.43,28.11Z"></path>
                  <path fill="var(--text-color)" d="M128.3,212.09q-5.75-5.4-17.07-5.4H88.9v65.68H99.5v-25.5h11.76q11.07,0,16.93-5.34t5.86-14.65Q134,217.49,128.3,212.09Zm-5.05,14.79h0q0,11.34-13.15,11.34H99.5V215.44h10.63q6.89,0,10,2.92t3.11,8.52Z"></path>
                  <polygon fill="var(--text-color)" points="152.25 264.09 174.94 264.09 174.94 272.37 141.64 272.37 141.64 206.69 152.25 206.69 152.25 264.09"></polygon>
                  <path fill="var(--text-color)" d="M215.78,207.72H203.6l-24.19,64.65h11.35l5-14.24H223.5l5,14.24h11.35Zm-17,42.23,10.88-30.69L220.53,250Z"></path>
                  <polygon fill="var(--text-color)" points="282.45 206.69 260.6 248.46 260.6 272.37 249.92 272.37 249.92 248.46 227.97 206.69 240.26 206.69 255.33 237.11 270.4 206.69 282.45 206.69"></polygon>
                </svg>
              </span>
              <span class="linktext">Pragmatic</span>
            </RouterLink>
          </span>
        </div>

        <div id="MyAccount" class="accounts-card">
          <div class="card-header">My Account</div>

          <span class="menulink" v-if="authStore.isAuthenticated">
            <RouterLink to="/my-account" @click="onNavigate">
              <span class="linkicon"><i class="fi fi-rr-user"></i></span>
              <span class="linktext">Profile</span>
            </RouterLink>
          </span>

          <span class="menulink" v-if="authStore.isAuthenticated">
            <RouterLink to="/my-bets" @click="onNavigate">
              <span class="linkicon"><i class="fi fi-rr-time-forward"></i></span>
              <span class="linktext">bet history</span>
            </RouterLink>
          </span>

          <span class="menulink" v-if="authStore.isAuthenticated">
            <RouterLink to="/deposit" @click="onNavigate">
              <span class="linkicon"><i class="fi fi-rr-wallet"></i></span>
              <span class="linktext">Deposit</span>
            </RouterLink>
          </span>

          <span class="menulink" v-if="authStore.isAuthenticated">
            <RouterLink to="/withdraw" @click="onNavigate">
              <span class="linkicon"><i class="fi fi-rr-wallet-arrow"></i></span>
              <span class="linktext">Withdraw</span>
            </RouterLink>
          </span>

<!--          <span class="menulink">
            <router-link :to="{ name: 'promotion' }">
              <span class="linkicon"><i class="fi fi-rr-gift"></i></span>
              <span class="linktext">promotions</span>
            </router-link>
          </span>

          <span class="menulink" v-if="authStore.isAuthenticated">
            <RouterLink :to="{ name: 'freebet' }">
              <span class="linkicon"><i class="fi fi-rs-badge-percent"></i></span>
              <span class="linktext">freebets</span>
            </RouterLink>
          </span>-->

          <span class="menulink">
            <a href="javascript:void(0);">
              <span class="linkicon"><i class="fi fi-rr-interrogation"></i></span>
              <span class="linktext">Help Center</span>
            </a>
          </span>
        </div>

        <div id="freeDataAd" class="accounts-card">
          <div class="freedata">
            <span class="toggle-btn">
              <label class="switch">
                <input type="checkbox" checked />
                <span class="slider round"></span>
              </label>
              Enable Free Data
              <span class="spec-icon offer">New</span>
            </span>

            <span class="float-right search-game-options"><i class="bi bi-chevron-right"></i></span>
          </div>
        </div>

        <div id="switchTheme" class="accounts-card">
          <div id="toggleTheme" @click="toggleTheme" style="cursor: pointer">
            <label>Switch between light theme and dark theme</label>
            <div class="toggle_theme_cta">
              Switch Mode
              <div class="modeswitch">
                <i
                  class="dark-theme fi fi-sr-brightness"
                  :style="{ display: isDarkMode ? 'inline' : 'none', color: '#ffc107' }"
                ></i>
                <i
                  class="light-theme fi fi-sr-moon-stars"
                  :style="{ display: isDarkMode ? 'none' : 'inline' }"
                ></i>
              </div>
            </div>
          </div>
        </div>

        <div id="sideBaradbanner">
          <div class="sidebar__ads">
            <img :src="images.adsBanner" alt="Ads" />
          </div>
        </div>

        <div id="logOut" class="accounts-card logout" v-if="authStore.isAuthenticated">
          <a href="javascript:void(0);" @click.prevent="handleLogout" style="text-decoration: none; color: inherit">
            <span class="account-icon"><i class="fi fi-rr-sign-out-alt"></i> Logout</span>
            <span class="float-right search-game-options"><i class="bi bi-chevron-right"></i></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import { CDN } from '@/config/cdn'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'
import { useFilterStorage } from '@/composables/useFilterStorage'
import axiosInstance from '@/api/axiosInstance'

const app = useAppStore()
const authStore = useAuthStore()
const router = useRouter()
const { setFilter, getFilter } = useFilterStorage()
const isDarkMode = ref(false)
const popularTournaments = ref([])

// Country code to flag mapping
const countryCodeMap = {
  GB: '121-england.png',
  ES: '230-spain.png',
  DE: '208-germany.png',
  IT: '263-italy.png',
  FR: '197-france.png',
  KE: '234-kenya.png',
  PT: '174-portugal.png',
  NL: '180-netherlands.png',
  BE: '191-belgium.png',
  GR: '200-greece.png',
  RU: '203-russia.png',
  UA: '221-ukraine.png',
  TR: '223-turkey.png',
  BR: '276-brazil.png',
  MX: '484-mexico.png',
  AR: '32-argentina.png',
  US: '226-united-states.png',
  CA: '36-canada.png',
  AU: '14-australia.png',
  JP: '112-japan.png',
  CN: '45-china.png',
  IN: '100-india.png',
}

function getCountryFlag(countryCode) {
  const flagFileName = countryCodeMap[countryCode] || '121-england.png'
  return CDN.countries(flagFileName)
}

function onNavigate() {
  app.closeSideMenu()
}

// Handle tournament click and navigate to home with filter
function handleTournamentClick(tournament) {
  // Get the current filter to preserve the active tab
  const currentFilter = getFilter()
  const currentTab = currentFilter?.tab || 'upcoming'

  // Store tournament filter data with preserved tab
  setFilter({
    tab: currentTab,
    tournament_id: tournament.tournament_id,
    sport_id: 10,
    market_id: 2,
    page_size: 20,
    page: 1,
  })

  // This ensures the route watcher triggers a refetch
  app.closeSideMenu()
  router.push({
    name: 'home',
    query: { tournament_id: tournament.tournament_id }
  })
}

// Logout functionality
function handleLogout() {
  authStore.logout()
  app.closeSideMenu()
  router.push('/')
}

// Theme switching functionality
function toggleTheme() {
  isDarkMode.value = !isDarkMode.value
  const body = document.body

  if (isDarkMode.value) {
    body.classList.add('dark-mode')
    body.classList.remove('light-mode')
    localStorage.setItem('theme', 'dark')
  } else {
    body.classList.remove('dark-mode')
    body.classList.add('light-mode')
    localStorage.setItem('theme', 'light')
  }

  // Dispatch custom event to notify other components (like AppHeader)
  window.dispatchEvent(new CustomEvent('themeChanged'))
}

// Fetch popular tournaments
async function fetchPopularTournaments() {
  try {
    const response = await axiosInstance.get('/tournaments/highlight')
    if (response.data && Array.isArray(response.data)) {
      // Take only the first 6 tournaments
      popularTournaments.value = response.data.slice(0, 6)
    }
  } catch (error) {
    console.error('Error fetching tournaments:', error)
    // Fallback to empty array on error
    popularTournaments.value = []
  }
}

// Initialize theme on component mount
onMounted(() => {
  const savedTheme = localStorage.getItem('theme')
  isDarkMode.value = savedTheme === 'dark'

  if (isDarkMode.value) {
    document.body.classList.add('dark-mode')
    document.body.classList.remove('light-mode')
  } else {
    document.body.classList.remove('dark-mode')
    document.body.classList.add('light-mode')
  }

  // Fetch popular tournaments
  fetchPopularTournaments()
})

const images = {
  logo: CDN.images('mossbets-logo.png'),
  logoReverse: CDN.images('mossbets-logo-reverse.png'),
  adsBanner: CDN.images('adsbanners.png'),
}
const icons = { globe: CDN.icons('icon_globe.png') }
</script>
